import asyncComponent from "../components/AsyncComponent";
export default [
    {
        path: "/login",
        title: "登录",
        name:"login",
        component: asyncComponent(() => import("../pages/login"))
    },
    {
        path: "/mallms/login",
        name: "mallms:login",
        title:"登陆",
        component: asyncComponent(() => import("../mallms/pages/Login"))
    },
    {
        path: "/mallms/*",
        title: "Mall管理系统",
        name:"mall",
        component: asyncComponent(() => import("../layout/MallBaLayout"))
    },
    {
        path: "/shopms/login",
        name: "shopms:login",
        title:"登陆",
        component: asyncComponent(() => import("../shopms/pages/Login"))
    },
    {
        path: "/shopms/*",
        title: "门店管理系统",
        name:"mall",
        component: asyncComponent(() => import("../layout/ShopMsBaLayout"))
    },
    {
        path:"/invite-code/query",
        title: "邀请码记录查询",
        name:"invite-code-query",
        component: asyncComponent(() => import("../mms/invite-code/query-records"))
    },
    {
        path:"/dashboard/home",
        title:"仪表盘",
        name:"dashboard:home", 
        component:asyncComponent(()=> import("../mms/dashboard/home"))
    },
    {
        path: "/", 
        name:"admin",
        title:"管理后台",
        component:asyncComponent(()=>import("../layout/BaLayout"))
        
    }
   



]